import type { GetTransferProductsQuery } from "graphql-api/operations";

export async function fetchTransferProducts(): Promise<GetTransferProductsQuery> {
  // Dynamic import to avoid circular dependencies
  const { graphqlClient } = await import("@design-lab/shared/graphql");
  const { GetTransferProductsDocument } = await import("graphql-api/operations");

  const result = await graphqlClient.query({
    query: GetTransferProductsDocument,
    fetchPolicy: "network-only"
  });

  if (!result.data) {
    throw new Error("No data returned from transfer products query");
  }

  return result.data;
}
